"use client";

import AuthLayout from "@/components/auth/auth-layout";
import { FormProvider } from "@/providers/form.provider";
import type { SignupValues } from "@/utils/validations/auth/signup";
import {
  signupDefaultValues,
  signupSchema,
} from "@/utils/validations/auth/signup";
import SignUpCard from "./signup-card";

const SignupScreen = () => {
  return (
    <AuthLayout className="py-8" contentClassName="relative z-10 w-full px-4">
      <FormProvider<SignupValues>
        schema={signupSchema}
        defaultValues={signupDefaultValues}
      >
        <SignUpCard />
      </FormProvider>
    </AuthLayout>
  );
};

export default SignupScreen;
